'use client';

import React, { ComponentProps } from 'react';
import { Box, Text } from '@skin-seoul/design-system';
interface CategoryButtonProps extends Omit<ComponentProps<typeof Box>, 'onClick'> {
  name: string;
  isSelected: boolean;
  onClick: () => void;
}
const CategoryButton = ({
  name,
  isSelected,
  onClick,
  ...rest
}: CategoryButtonProps) => {
  return <Box as="button" onClick={onClick} paddingX={5} paddingY={2.5} borderRadius="100px" backgroundColor={isSelected ? 'generic.0' : 'transparent'} borderWidth="1px" borderColor={isSelected ? 'transparent' : 'neutral.200'} transition="all 0.2s" whiteSpace="nowrap" cursor="pointer" {...rest} data-sentry-element="Box" data-sentry-component="CategoryButton" data-sentry-source-file="CategoryButton.tsx">
      <Text textStyle="paragraph.small" fontWeight="regular" color={isSelected ? 'generic.100' : 'neutral.100'} data-sentry-element="Text" data-sentry-source-file="CategoryButton.tsx">
        {name}
      </Text>
    </Box>;
};
export default CategoryButton;